let language = {
    "LBL_HOME":"Home",
    "LBL_BUDGETS": "Budgets",
    "LBL_VIEW_BUDGETS": "View Budgets",
    "LBL_ADD_BUDGETS": "Create Budgets",
    "LBL_TEMPLATE_NAME":"Template Name",
    "LBL_CURRENCY_MULTIPLIER":"Currency Multiplier",
    "LBL_CURRENCY":"Currency",
    "LBL_YEARS":"Years",
    "LBL_SNo":"S.No.",
    "LBL_TEMPLATE_YEAR":"Template Year",
    "LBL_TEMPLATE_STATUS":"Template Status",
    "LBL_ACTION_EDIT":"Edit",
    "LBL_ACTION_DELETE":"Delete",
    "LBL_ACTION_DUPLICATE":"Duplicate",
    "LBL_STATUS":"Status",
    "LBL_HAS_ATTACHMENT":"Has Attachment?",
    "LBL_SELECT_FILE":"Select File",
    "LBL_ATTACHED_FILE":"Attached File",
}

export default language;